class Oneri {
    
    zone = [
        {
            scaglioni: [        // Valle d'Aosta, Piemonte, Liguria
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        },
        {
            scaglioni: [        // Lombardia, Trentino-Alto Adige, Veneto, Friuli-Venezia Giulia, Emilia-Romagna
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        },
        {
            scaglioni: [        // Toscana, Umbria, Marche
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        },
        {
            scaglioni: [        // Abruzzo, Molise, Puglia, Basilicata
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        },
        {
            scaglioni: [        // Lazio, Campania
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        },
        {
            scaglioni: [        // Calabria, Sicilia
                0.00222, 0.04842, 0.02952, 0.02432, 0.01802, 0.00882
            ],
            fisso: -26.13
        }

    ]

    getCluster( regione ){
        let zona = this.zone[0];
        switch (regione) {
            case 'Lombardia':
            case 'Trentino-Alto Adige':
            case 'Veneto':
            case 'Friuli-Venezia Giulia':
            case 'Emilia-Romagna':
                zona = this.zone[1];
            break;
            case 'Toscana':
            case 'Umbria':
            case 'Marche':
                zona = this.zone[2];
            break;
            case 'Abruzzo':
            case 'Molise':
            case 'Puglia':
            case 'Basilicata':
                zona = this.zone[3];
            break;
            case 'Lazio':
            case 'Campania':
                zona = this.zone[4];
            break;
            case 'Calabria':
            case 'Sicilia':
                zona = this.zone[5];
            break;
            case "Val d'Aosta":
            case "Piemonte":
            case "Liguria":
            default:
                // do nothing we are already in the right zone
                break;
        }

        return zona;
    }

}
export default new Oneri();